import React from 'react';
import { Grid, Typography } from '@rentacenter/racstrap';

interface NoRecordsFoundProps {
  message?: string;
}

const NoRecordsFound: React.FC<NoRecordsFoundProps> = ({
  message = 'No result found',
}) => {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ padding: '100px 20px' }}
    >
      <Grid item>
        <Typography
          variant="body1"
          style={{
            color: '#333',
            textAlign: 'center',
            fontSize: '16px',
            fontWeight: 400,
          }}
        >
          {message}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default NoRecordsFound;
